import React, {useState} from 'react';
import './Canvas.scss';
import Sketch from 'react-p5'
import { useTheme } from '../../contexts/ThemeContext';


const Bubbles = ({colors}) => {
    const  darkTheme = useTheme();
    const [strokeColor, setStrokeColor] = useState([0, 0, 0])
    const [select, setSelect] = useState([0,0,0]);
   
    const setup = (p5, canvasParentRef) => {
        p5.createCanvas(300,300).parent(canvasParentRef);
        p5.background(255);
 
    }

    const draw = (p5) => {
        if (p5.mouseX > 0 && p5.mouseX < p5.width && p5.mouseY > 0 && p5.mouseY < p5.height){
       if (p5.mouseIsPressed){
           for (let i = 0; i < 10; i++){

            
            p5.fill(255);
            p5.stroke(strokeColor[0], strokeColor[1], strokeColor[2]);
            let wave = p5.sin(p5.radians(p5.random(3000, 5000)))
            p5.circle(p5.mouseX + i, p5.mouseY + i, p5.width / p5.mouseX + wave * i, p5.height + wave * i);

            p5.fill(strokeColor[0], strokeColor[1], strokeColor[2]);
            p5.stroke(255);
            p5.circle(p5.width / i + wave * 300, p5.mouseY + wave * 300, p5.random(5, 15) + wave * i, p5.random(5,10) * wave * (200/i));            
           }   
       }
       
    }
    }
    const handleStrokeColor = (color) => {
        setStrokeColor(color)
        setSelect(color)
    }

    return (
        <div className={(darkTheme) ? "canvas-container-dark" : "canvas-container"}>
            <Sketch className="canvas-1"setup={setup} draw={draw}/>
            <div className="canvas-colors"> 
            {colors.map((col, i) => {
                return (  
                    <div className="canvas-box"onClick={()=>{handleStrokeColor(col)}} key={i} style={{backgroundColor: `rgb(${col})`, height: "60px", width: "60px", flex: "1"}}></div>
                )
            })}
             <div className="canvas-selected" style={{borderRadius: "20px", height: "20px", background:`rgb(${select})`}}></div>
            </div>
           
        </div>
    )
}

export default Bubbles
